import { mmDDYYYY } from '../utils/placeHolderFormat';
const fields = [
    {
        "label": "Do you currently have car insurance?",
        "type": "select",
        "name": "policyStatus",
        "component": "select",
        "options": [
            {
                "code": "INFORCE",
                "description": "Yes, I have my own policy"
            },
            {
                "code": "2122",
                "description": "Yes, On another's policy with proof of insurance"
            },
            {
                "code": "2123",
                "description": "Yes, On another's policy without proof of insurance"
            },
            {
                "code": "169",
                "description": "No, I've been deployed overseas"
            },
            {
                "code": "170",
                "description": "No, I just acquired a car"
            },
            {
                "code": "EXPIRED",
                "description": "No, My policy expired more than 30 days ago"
            },
            {
                "code": "168",
                "description": "No, My policy expired less than 30 days ago"
            },{
                "code":"CANCELLED",
                "description": "No, My policy has been cancelled"
            }
        ],
    },
    {
        "type": "text",
        "component": "input",
        "label": "Who is your most recent insurance company?",
        "name": "carrier"
    },
    {
        "label": "How long have you been with your most recent insurance company?",
        "type": "select",
        "name":"howlongcontinuouslyinsured",
        "component": "select",
        "options": [
            {
                "code": "2109",
                "description": "1 month"
            },
            {
                "code": "2110",
                "description": "2 months"
            },
            {
                "code": "2111",
                "description": "3 months"
            },
            {
                "code": "2112",
                "description": "4 months"
            },
            {
                "code": "2113",
                "description": "5 months"
            },
            {
                "code": "2114",
                "description": "6 months"
            },
            {
                "code": "2115",
                "description": "7 months"
            },
            {
                "code": "2116",
                "description": "8 months"
            },
            {
                "code": "2117",
                "description": "9 months"
            },
            {
                "code": "2118",
                "description": "10 months"
            },
            {
                "code": "2119",
                "description": "11 months"
            },
            {
                "code": "115",
                "description": "1 year"
            },
            {
                "code": "116",
                "description": "2 years"
            },
            {
                "code": "3 years",
                "description": "3 years"
            },
            {
                "code": "118",
                "description": "4 years"
            },
            {
                "code": "192",
                "description": "5 years"
            },
            {
                "code": "193",
                "description": "6 years"
            },
            {
                "code": "776",
                "description": "7 years"
            },
            {
                "code": "718",
                "description": "8 years"
            },
            {
                "code": "719",
                "description": "9 years"
            },
            {
                "code": "720",
                "description": "10 years"
            },
            {
                "code": "721",
                "description": "11 years"
            },
            {
                "code": "722",
                "description": "12 years"
            },
            {
                "code": "723",
                "description": "13 years"
            },
            {
                "code": "724",
                "description": "14 years"
            },
            {
                "code": "725",
                "description": "15 years"
            },
            {
                "code": "726",
                "description": "16 years"
            },
            {
                "code": "727",
                "description": "17 years"
            },
            {
                "code": "728",
                "description": "18 years"
            },
            {
                "code": "729",
                "description": "19 years"
            },
            {
                "code": "730",
                "description": "20 years"
            },
            {
                "code": "731",
                "description": "21+ years"
            }
        ],
        "errorMessages": [
            {
                "code": "required",
                "description": "Please select a value from the drop-down list."
            }
        ]
    },
    {
        "name": "hasPossibleLapse",
        "label": "Have you been uninsured at any time in the past 3 years?",
        "type": "select",
        "component": "select",
        "options": [
            {
                "code": "N",
                "description": "No, I was continuously insured"
            },
            {
                "code": "Y",
                "description": "Yes, within the last 3 years"
            }
        ],
        "errorMessages": [
            {
                "code": "required",
                "description": "Please indicate if you have been uninsured in the past 3 years."
            }
        ]

    },
    {
        "label": "What are your most recent Bodily Injury (BI) limits?",
        "type": "select",
        "name":"bodilyInjury",
        "component": "select",
        "options": [
            {
                "code": "",
                "description": "Minimum limit"
            },
            {
                "code": "40000:80000",
                "description": "Greater than minimum but less than 50/100"
            },
            {
                "code": "50000:100000",
                "description": "50/100 or greater but less than 100/300"
            },
            {
                "code": "100000:300000",
                "description": "100/300 or greater"
            }
        ]
    },
    /*
    {
        "type": "text",
        "component": "input",
        "label": "policyNumber",
        "name": "policyNumber"
    },
    */
    /*
    {
        "type": "text",
        "component": "input",
        "label": "policyType",
        "name": "policyType"
    },
    
    {
        "type": "text",
        "component": "input",
        "label": "Is this ",
        "name": "compOnlyPolicy"
    }, 
    */
    /*
    {
        "type": "text",
        "component": "input",
        "label": "policyReportedDate",
        "name": "policyReportedDate"
    },
    
    {
        "type": "text",
        "component": "input",
        "label": "How long have you been with your current insurer?",
        "name": "yearsWithCurrentInsurer",
        "options": [
            {
                code: '1',
                description: '1 yr'
            },
            {
                code: '2',
                description: '2 yr'
            },
            {
                code: '3',
                description: '3 yr'
            }
        ]
    },    
    {
        "type": "text",
        "component": "input",
        "label": "inceptionDate",
        "name": "inceptionDate"
    },
    */

    /*
    {
        "type": "text",
        "component": "input",
        "label": "lastReportedTermEffectiveDate",
        "name": "lastReportedTermEffectiveDate"
    }, 
    
    {
        "type": "text",
        "component": "input",
        "label": "numberOfCancellations",
        "name": "numberOfCancellations"
    },
    
    {
        "type": "text",
        "component": "input",
        "label": "numberOfRenewals",
        "name": "numberOfRenewals"
    }, 
    
    {
        "type": "radio",
        "component": "input",
        "label": "Has there been a lapse in your insurance coverage?",
        "name": "hasPossibleLapse",
        "options": [
            {
                "code": "Y",
                "description": "Yes"
            },
            {
                "code": "N",
                "description": "No"
            }
        ]
    },
    */
   
    /*
    {
        "type": "text",
        "component": "input",
        "label": "How long have you been with your current insurer?",
        "name": "numberOfCoverageDays"
    },
    */
    /*
    {
        "type": "text",
        "component": "input",
        "label": "hasBreakFromPriorCoverage",
        "name": "hasBreakFromPriorCoverage"
    },
    
    {
        "type": "text",
        "component": "input",
        "label": "Days of lapse with current insurer.",
        "name": "numberOfLapseDays"
    },
    */
    /*
    {
        "type": "text",
        "component": "input",
        "label": "coverages",
        "name": "coverages"
    },
    
    {
        type: "text",
        component: "input",
        label: "Bodily Injury",
        name: 'bodilyInjury'
    },
    */
    {
        type: "select",
        component: "select",
        label: "Property Damage",
        name: 'propertyDamage',
        "options": [
            {
              "code": "15000:20000",
              "description": "Minimum limit"
            },
            {
              "code": "20000:40000",
              "description": "Greater than minimum but less than 40"
            },
            {
              "code": "30000:60000",
              "description": "30/60 or greater but less than 80"
            },
            {
              "code": "40000:80000",
              "description": "80 or greater"
            }
          ],
    },
    /*
    {
        "name": "howlonglapse",
        "label": "How long were you without insurance?",
        "type": "select",
        "component": "select",
        "options": [
            {
                "code": "2149",
                "description": "1-7 days"
            },
            {
                "code": "2150",
                "description": "8-30 days"
            },
            {
                "code": "2151",
                "description": "31-60 days"
            },
            {
                "code": "2152",
                "description": "61-90 days"
            },
            {
                "code": "2153",
                "description": "90+ days"
            }
        ],
        "errorMessages": [
            {
                "code": "required",
                "description": "Please indicate how long you were uninsured."
            }
        ]
    },
    */
    {
        "name": "lastReportedTermExpirationDate",
        "label": "Policy expiration date",
        "placeholder":mmDDYYYY,
        "helptext": ":Your current policy expiration date cannot be more than 13 months in the future or 1 month in the past. Please note you can cancel your current policy at any time, regardless of its expiration date.",
        "component": "input",
        "type": "text",
        "errorMessages": [
            {
                "code": "required",
                "description": "Please indicate the expiration date of your policy in mm/dd/yyyy format."
            },
            {
                "code": "maxvalue_166",
                "description": "Policy expiration date cannot be more than 13 months in the future."
            },
            {
                "code": "minvalue_166",
                "description": "Policy expiration date must be tomorrow or after, as you have indicated that you are currently insured."
            },
            {
                "code": "invalid",
                "description": "Please enter a valid date."
            },
            {
                "code": "pattern",
                "description": "Please indicate the expiration date of your policy in mm/dd/yyyy format."
            },
            {
                "code": "minvalue_168",
                "description": "Policy expiration date cannot be more than 30 days in the past, as you have indicated that your policy expired less than 30 days ago."
            },
            {
                "code": "maxvalue_168",
                "description": "Policy expiration date must be today or in the past, as you have indicated that you are not currently insured."
            }
        ]
    },
    
    {
        "name": "newpolicystartdate",
        "label": "New policy start date",
        "placeholder":mmDDYYYY,
        "helptext": ":Please enter a date that is equal to or earlier than your policy expiration date. Otherwise, you may have a lapse in coverage and receive an inaccurate rate. :: :In addition, your new policy must start within the next 30 days. Therefore, you must enter a date that is no more than 30 days in the future. Please note that you can cancel your old policy and start a new one at any time.",
        "component": "input",
        "type": "text",
        "errorMessages": [
            {
                "code": "required",
                "description": "Please enter the date you would like your new policy to start in mm/dd/yyyy format."
            },
            {
                "code": "minvalue",
                "description": "Your new policy cannot start in the past."
            },
            {
                "code": "maxvalue",
                "description": "Your new policy must start within the next 30 days."
            },
            {
                "code": "invalid",
                "description": "Please enter a valid date."
            },
            {
                "code": "pattern",
                "description": "Please enter the date you would like your new policy to start in mm/dd/yyyy format."
            },
            {
                "code": "additional",
                "description": "Please enter a date that is equal to or before your policy expiration date.  Otherwise you may have a lapse in coverage and receive an inaccurate rate."
            }
        ]
    },
    /*
    {
        "name": "accidentclaimviolationinpast5years",
        "label": "Have any drivers on this policy had any accidents, moving violations, or claims in the last 5 years?",
        "helptext": ":Please answer \"yes\" if any driver has received any tickets, filed a claim with their insurance company, or had any accidents, including those for which the driver(s) were not at fault. You will have a chance to tell us the details of the incident(s) on the next page.",
        "type": "radio",
        "component": "input",
        "options": [
            {
                "code": "2016",
                "description": "No"
            },
            {
                "code": "2017",
                "description": "Yes"
            }
        ],
        "errorMessages": [
            {
                "code": "required",
                "description": "Please make a selection."
            }
        ]
    },
    {
        "name": "driverrequiresfinancialresponsibilitydocument",
        "label": "Do any drivers on this policy require a SR-22 or other Financial Responsibility document? (If you do not know, select  'No')",
        "helptext": ":An SR-22 is a document certifying that you meet the state’s minimum insurance requirements. People who require an SR-22 generally have a serious traffic violation on their record and need to find an insurance company that will submit the form on behalf of the customer.",
        "type": "radio",
        "component": "input",
        "options": [
            {
                "code": "2016",
                "description": "No"
            },
            {
                "code": "2017",
                "description": "Yes"
            }
        ],
        "errorMessages": [
            {
                "code": "required",
                "description": "Please make a selection."
            }
        ]
    },
    {
        "name": "whorequiresfinancialresponsibilitydocument",
        "label": "Please select the drivers on this policy that require a Financial Responsibility Document.",
        "helptext": "",
        "SortOrder": "",
        "options": "",
        "errorMessages": ""
    },
    {
        "name": "electronicdocuments",
        "label": "Are you willing to sign and receive insurance policy documents electronically?",
        "helptext": ":Some insurance companies may provide discounts if you are willing to service your account electronically.",
        "type": "radio",
        "component": "input",
        "options": [
            {
                "code": "118",
                "description": "Receive"
            },
            {
                "code": "116",
                "description": "Sign"
            }
        ],
        "errorMessages": ""
    }
    */
];

export default fields;




// WEBPACK FOOTER //
// ./src/History/fields.js